import { render } from "./Cursor.vue?vue&type=template&id=00d10df0"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__